module.exports = __webpack_public_path__ + "static/media/broken.29ae1727.jpg";